exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-home-remark[data-v-0448b1bf]{line-height:2;background:#95b3bf;font-size:12px;padding:10px 0;text-align:center}.page-home-remark .page-home-remark-a[data-v-0448b1bf]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.page-home-remark .page-home-remark-img[data-v-0448b1bf]{margin-right:2px}", ""]);

// exports
